export const setContentUrl = (id: string, contentType: string, contextId?: string | undefined) => {
  let contentRoute = '';

  if (contentType === 'multi_session_workshop') {
    contentRoute = `/multi-session-workshop/${id}`;
  } else if (contentType === 'imported_content') {
    contentRoute = `/imported-content/${id}`;
  } else {
    contentRoute = `/${contentType.toLowerCase()}/${id}`;
  }
  if (contextId && contentRoute.length) {
    contentRoute += `?contextId=${contextId}`;
  }

  return contentRoute;
};
